export default __webpack_public_path__ + "static/media/news1.c087552f.jpeg";